









import Vue from 'vue'
import { mapGetters } from 'vuex'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import { UserScope } from '@/models/users'

export default Vue.extend({
  components: {
    PaidLabel,
  },
  computed: {
    ...mapGetters({
      canDoScope: 'canDoScope',
    }),
    canInviteUsers(): boolean {
      return (
        this.canDoScope(UserScope.Roles) && this.canDoScope(UserScope.Users)
      )
    },
  },
})
